module.exports = __webpack_public_path__ + "static/young-leader-photo-rochelle_etwaroo-bfbfaf3d15fbd939cc97f5a7778ce39a.jpg";